import React, { useMemo, useState } from 'react';
import { useTranslation } from "react-i18next"
import { Button, ButtonList, Modal, PageHeader, PenModal, SECTION_ATTENTION, SECTION_BASIC, SECTION_REMAININGTODAY, SECTION_REMAININGYESTERDAY, SectionModal, Toggle } from "../../../Components"
import { colors, css, fonts, frames, glyphs, useMediaQuery } from '../../../Styles';

import { getSectionById, Sections } from '../../../Assets/TestData/sectionsData';
import { SectionBasicTypes } from '../../../Components/LocationFeeder/Section/sectionBasic';
import { SystemData } from '../../../Assets/TestData/systems';
import { ButtonTypes } from '../../../Definitions';
import NewSectionModal from '../../../Components/LocationFeeder/Modals/newSectionModal';

export default function FreedaLocationFeeder() {
  const {t} = useTranslation()
  const [isHoveredSection, setHoveredSection] = useState<number | null>(null);
  const [activeSectionId, setActiveSectionId] = useState<number | null>(null);
  const [activePenId, setActivePenId] = useState<number | null>(null);
  const [isRemainingToday, setRemainingToday] = useState<boolean>(false) // Section Remaining Today
  const [isRemainingYesterday, setRemainingYesterday] = useState<boolean>(false) // Section Remaining Yesterday
  const [attention, setAttention] = useState<boolean>(false) // Section Attentions
  const [editTable, setEditTable] = useState(false)
  const [newSectionModal, setNewSectionModal] = useState(false)
  const mobileXs = useMediaQuery(`(max-width: 450px)`);
  

  // System Name
  const { systemName } = useMemo(() => {
    const systemData = SystemData.find((system) => system.systemId === 2);
    return {
      systemName: systemData?.systemName || "",
    };
  }, []);

  // Extract section IDs from Sections data
  const sectionIds = Sections.map(section => section.id);

  // Save first sectionId and lastsection Id
  const firstSectionId = sectionIds[0];
  const lastSectionId = sectionIds[sectionIds.length - 1];

  // #region | Sections Functionality (toggles, section-click)
  // Set the clicked sectionId as active
  const handleSectionClick = (sectionId: number) => {
    setActiveSectionId(sectionId); 
    setActivePenId(null);
  };

  // Toggle Btn Remaining Today
  const toggleRemainingToday = () => {
    if (isRemainingToday) {
      setRemainingToday(false); // If already active, set it to false
    } else {
      setRemainingToday(true);
      setRemainingYesterday(false);
      setAttention(false);
    }
  };
  
  // Toggle Btn Remaining Yesterday
  const toggleRemainingYesterday = () => {
    if (isRemainingYesterday) {
      setRemainingYesterday(false); // If already active, set it to false
    } else {
      setRemainingYesterday(true);
      setRemainingToday(false);
      setAttention(false);
    }
  };

  // Toggle Btn Attentions
  const toggleAttentions = () => {
    if (attention) {
      setAttention(false); // If already active, set it to false
    } else {
      setAttention(true);
      setRemainingYesterday(false);
      setRemainingToday(false);
      
    }
  };

  // Switch between edit mode and non-edit mode
  const switchTable = () => {
    setEditTable((editTable) => !editTable);
    setAttention(false)
    setRemainingToday(false)
    setRemainingYesterday(false)
  };
  // #endregion

  // #region | Modal Functionality (next/previous btns, pen-click)
  // Function to handle pen selection from SectionModal
  function handlePenSelected(penId: number) {
    setActivePenId(penId);  // Set the active pen to open the PenModal
  }

  // Next Section
  const goToNext = () => {
    if (activeSectionId !== null) {
      const currentIndex = sectionIds.indexOf(activeSectionId);
      const nextIndex = currentIndex + 1 >= sectionIds.length ? 0 : currentIndex + 1; // Wrap around to first section
      setActiveSectionId(sectionIds[nextIndex]);
      setActivePenId(null); // Reset active pen when changing sections
    }
  };

  // Previous Section
  const goToPrevious = () => {
    if (activeSectionId !== null) {
      const currentIndex = sectionIds.indexOf(activeSectionId);
      const previousIndex = currentIndex - 1 < 0 ? sectionIds.length - 1 : currentIndex - 1; // Wrap around to last section
      setActiveSectionId(sectionIds[previousIndex]);
      setActivePenId(null); // Reset active pen when changing sections
    }
  };

  // Next Pen
  function getNextPen(sectionId: number, currentPenId: number) {
    const section = getSectionById(sectionId);
    if (!section) return null;
  
    const currentPenIndex = section.pens.findIndex(pen => pen.penId === currentPenId);
    const nextPenIndex = (currentPenIndex + 1) % section.pens.length;
  
    return section.pens[nextPenIndex];
  }
  const handleNextPen = () => {
    if (activeSectionId !== null && activePenId !== null) {
      const nextPen = getNextPen(activeSectionId, activePenId);
      if (nextPen) {
        setActivePenId(nextPen.penId);
      }
    }
  };

  // Previous Pen
  function getPreviousPen(sectionId: number, currentPenId: number) {
    const section = getSectionById(sectionId);
    if (!section) return null;
  
    const currentPenIndex = section.pens.findIndex(pen => pen.penId === currentPenId);
    const previousPenIndex = (currentPenIndex - 1 + section.pens.length) % section.pens.length;
  
    return section.pens[previousPenIndex];
  }
  const handlePreviousPen = () => {
    if (activeSectionId !== null && activePenId !== null) {
      const previousPen = getPreviousPen(activeSectionId, activePenId);
      if (previousPen) {
        setActivePenId(previousPen.penId);
      }
    }
  };

  // Go to previous label
  const previousLabel = !activePenId&&activeSectionId?
  t("buttons.prev") + " " + t("locationFeeder.sections.section")
  : activePenId ?
  t("buttons.prev") + " " + t("locationFeeder.penPopup.pen")
  : ""

  // Go to next label
  const nextLabel = !activePenId&&activeSectionId?
  t("buttons.next") + " " + t("locationFeeder.sections.section")
  : activePenId ?
  t("buttons.next") + " " + t("locationFeeder.penPopup.pen")
  : ""
  //#endregion

  // #region | Modal Components (btns)
  const prevNextBtns = 
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "10px", height: "20px" }}>
      <div style={{ height: "20px", display: "flex" }}>
        <Button 
          content={previousLabel}
          startEnhancer={glyphs.Arrow({rotate: 180})}
          buttonType={ButtonTypes.textButton}
          onClick={activePenId? handlePreviousPen : goToPrevious }
          overrides={{
            baseButton: {...fonts.fontSize4}
          }}
        />
      </div> 
      <div style={{ backgroundColor: colors.blueDarkSecondary, height: "20px", width: "1.5px", margin: "0 auto" }}/>
      <div style={{ height: "20px", display: "flex" }}>
        <Button 
          content={nextLabel}
          endEnhancer={glyphs.Arrow({})}
          buttonType={ButtonTypes.textButton}
          onClick={activePenId? handleNextPen : goToNext}
          overrides={{
            baseButton: {...fonts.fontSize4}
          }}
        />
      </div>
    </div>
  // #endregion

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <PageHeader topHeader={systemName} subHeader={t("locationFeeder.sections.sections")}/>
      </frames._page_inner_header>
      <frames._page_inner_content>
        {editTable
          ? <div style={{...css.backdropFilter, zIndex: "1"}}/>
          : undefined 
        }
        <div style={{height: "100%", width: "100%", display: "grid", gridAutoRows: "50px calc(100% - 50px)", zIndex: "2", position: "relative"}}>
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "end", padding: "0px 20px"}}>
            <p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, marginBottom: "5px" }}>{t("locationFeeder.sections.section")} {firstSectionId} {t("locationFeeder.sections.to")} {lastSectionId}</p>
          
          <div style={{ backgroundColor: "transparent", display: "flex", justifyContent: "end", gap: "5px"}}>
            {!editTable? 
              <ButtonList 
                contents={[t("buttons.add"), t("buttons.edit")]} 
                onClick={(i => {
                  if (i === 0) {setNewSectionModal(true)}
                  else if (i === 1) switchTable()
                })}
                buttonType={ButtonTypes.tableButton}
                startEnhancers={[glyphs.Add({}), glyphs.Edit({})]}
              />
            : <ButtonList 
                contents={[t("buttons.saveBtn"), t("buttons.cancelBtn"),t("buttons.add"), t("buttons.edit")]} 
                onClick={(i => {
                  if (i === 0) {}
                  else if (i === 1) switchTable()
                })}
                buttonType={ButtonTypes.tableButton}
                startEnhancers={[glyphs.Check({}), glyphs.Close({}), glyphs.Add({}), glyphs.Edit({})]}
                disabled={[false, false, true, true]}
                overrides={(index) => ({
                  baseButton: {
                    backgroundColor: index === 3 ? colors.greyPrimary : colors.greySecondary
                  },
                  disabledStyles: {
                    opacity: index === 3 ? 1 : 0.5
                  }
                })}
              />
            }
          </div>
          </div>
          <frames.Grid_oneRow>
            <frames._grid_oneRow_top>
              <div style={{display: "flex", flexDirection: "row", alignItems: "center", columnGap: mobileXs ? "10px" : "30px", rowGap: "10px", flexWrap: "wrap"}}>
                {/* <p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary }}>{t("locationFeeder.sections.section")} {firstSectionId} {t("locationFeeder.sections.to")} {lastSectionId}</p> */}
                <Toggle isDisabled={editTable? true : false} label={t("feed.remaining.today")} icon={glyphs.TimeToday({size: "17px"})} onChange={() => toggleRemainingToday()} isChecked={isRemainingToday? true : false}/> 
                <Toggle isDisabled={editTable? true : false} label={t("feed.remaining.yesterday")} icon={glyphs.TimeYesterday({size: "17px"})} onChange={() => toggleRemainingYesterday()} isChecked={isRemainingYesterday? true : false}/>
                <Toggle isDisabled={editTable? true : false} label={t("attentions.attentions")} icon={glyphs.Attention({size: "17px"})} onChange={() => toggleAttentions()} isChecked={attention? true : false}/>
              </div>
            </frames._grid_oneRow_top>
            <frames._grid_oneRow_content style={{
              display: "flex",
              justifyContent: mobileXs ? "center" : "start",
              gap: "20px",
              padding: "20px",
              flexWrap: "wrap"
            }}>
              {sectionIds.map((sectionId) => (
                <div key={sectionId} 
                  onClick={() => handleSectionClick(sectionId)}
                  onMouseEnter={() => setHoveredSection(sectionId)}
                  onMouseLeave={() => setHoveredSection(null)}
                  style={{ 
                    filter:  isHoveredSection === sectionId ? 'opacity(0.5)' : 'opacity(1)',
                    cursor: "pointer",
                    transition: 'filter 0.3s',
                    width: "fit-content",
                    height: "fit-content",
                  }} >
                    { isRemainingToday?
                      <SECTION_REMAININGTODAY
                      sectionId={sectionId}/>
                    : isRemainingYesterday?
                      <SECTION_REMAININGYESTERDAY 
                      sectionId={sectionId}/>
                    : attention?
                      <SECTION_ATTENTION
                      sectionId={sectionId}/>
                    : <SECTION_BASIC 
                      sectionId={sectionId} 
                      sectionType={SectionBasicTypes.basicPen}/>
                    }
                </div>
              ))}
            </frames._grid_oneRow_content>
          </frames.Grid_oneRow>
        </div>
      </frames._page_inner_content>

      {/* Section and pen Modals */}
      <Modal 
        isModalOpen={!!activeSectionId || !!activePenId}
        modalHeader={ activePenId? t("locationFeeder.penPopup.pen")+" "+`${activePenId}` : t("locationFeeder.sections.section")+" "+`${activeSectionId}` }
        modalSubHeader={ activePenId? `System Name X ${t("locationFeeder.sections.section")} ${activeSectionId}` : `System Name X` } // TODO MAJA: System navn
        overrides={{
          isPrimaryComponent: false,
          root: { padding: "40px 5px 5px 5px" },
          background: colors.greyLightTertiary
        }}
        onCloseBtn={() => {
          setActiveSectionId(null)
          if (activePenId) setActivePenId(null)
        }}
        onGoBack={activePenId?() => setActivePenId(null) : undefined}
        modalHeaderContent={ <> {prevNextBtns} </> }
      >
        <>
          { !activePenId&&activeSectionId? 
            <SectionModal activeSectionId={activeSectionId} onPenSelected={handlePenSelected}/> // SECTION POPUP
          : activePenId? 
            <PenModal activePenId={activePenId}/> // PEN POPUP
          : null 
          }
        </>
      </Modal>

      <NewSectionModal 
        isModalOpen={newSectionModal}
        closeModal={() => setNewSectionModal(false)}
      />

    </frames.Page_inner>
  )
} 